import React from 'react';
import PropTypes from 'prop-types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { connect } from 'react-redux';
import { createTranslateUtilitySuccess, createTranslateUtilityFailure } from 'store/actions/utilities/translateActions';
import utils from 'helpers/utils';

export default function (WrappedComponent) {
    class Translator extends React.Component {
        static propTypes = {
            sendFailure: PropTypes.func.isRequired,
            sendSuccess: PropTypes.func.isRequired,
            updateTranslation: PropTypes.func.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (utils.diffObjects(nextProps, this.props)) {
                return true;
            }

            return false;
        }

        handleChange = (source, target, text, type) => {
            const {
                sendFailure,
                sendSuccess,
                updateTranslation,
            } = this.props;

            const data = {
                'source_language': source,
                'target_language': target,
                'text': text,
            };

            this.setState({
                loading: true,
            }, () => {
                const url = `${ config.getApiBaseUrl() }/utilities/translate`;

                return apiClient.create(url, data).then((response) => {
                    sendSuccess(response);

                    updateTranslation(response.target_language, response.translation, type);
                }, (error) => {
                    sendFailure(error);
                }).then(() => {

                    // This setTimeout will prevent the loading indicator from updating so the animation will run once.
                    window.setTimeout(() => {
                        this.setState({
                            loading: false,
                        });
                    }, 1500);
                });
            });
        }

        render() {
            return <WrappedComponent
                { ...this.props }
                handleTranslation={ (source, target, text, type) => {
                    this.handleChange(source, target, text, type);
                } }
            />;
        }
    }

    function mapDispatchToProps(dispatch) {
        return {
            sendFailure: (error) => {
                dispatch(createTranslateUtilityFailure(error));
            },
            sendSuccess: (response) => {
                dispatch(createTranslateUtilitySuccess(response));
            },
        };
    }

    return connect(
        null,
        mapDispatchToProps,
    )(Translator);
}



// WEBPACK FOOTER //
// ./src/components/hoc/translator.js